;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('callbackOnLastRepeaterItem', callbackOnLastRepeaterItem)

  function callbackOnLastRepeaterItem () {
    return function (scope, iElement, iAttrs) {
      if (scope.$last) {
        scope[iAttrs.callbackOnLastRepeaterItem](scope.$index)
      }
    }
  }
})()
